import { render, staticRenderFns } from "./Boxes.vue?vue&type=template&id=6413aab9&scoped=true"
import script from "./Boxes.vue?vue&type=script&lang=js"
export * from "./Boxes.vue?vue&type=script&lang=js"
import style0 from "./Boxes.vue?vue&type=style&index=0&id=6413aab9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6413aab9",
  null
  
)

export default component.exports